// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_HAMILTON_METHOD_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_HAMILTON_METHOD,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      outputFiles: {
        systemName: 'outputFiles',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      connectionId: {
        kind: 'string',
        required: true
      },
      methodFilePath: {
        kind: 'string',
        required: true
      },
      simulation: {
        kind: 'boolean',
        required: false
      },
      runtimeParameters: {
        kind: 'array',
        required: false,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            name: {
              kind: 'string',
              required: true
            },
            value: {
              kind: 'string',
              required: true
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
